import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "w-10px d-inline-block" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: _ctx.selectedTab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTab) = $event)),
    type: _ctx.type,
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createBlock(_component_el_tab_pane, {
          class: "tab-pane",
          key: index,
          label: tab.title,
          name: tab.name,
          closable: tab.closable,
          lazy: ""
        }, _createSlots({
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(tab.component), _mergeProps({
                key: tab.name
              }, tab.props, {
                "is-active": _ctx.selectedTab === tab.name
              }), null, 16, ["is-active"]))
            ], 1024))
          ]),
          _: 2
        }, [
          (tab.icon)
            ? {
                name: "label",
                fn: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(tab.icon)
                    }, null, 2),
                    _createTextVNode(_toDisplayString(tab.title) + " ", 1),
                    _hoisted_1
                  ])
                ])
              }
            : undefined
        ]), 1032, ["label", "name", "closable"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "type"]))
}